import React from 'react';
import { Nav, Row, Col } from 'react-bootstrap';

// Define the props using an interface
interface PageHeaderProps {
  activeTab: string;
  // Renamed for clarity, this function now handles navigation
  onTabSelect: (tabName: string) => void; 
  tabs: string[];
  HeaderComponent?: React.ReactNode;
}

const PageHeader2: React.FC<PageHeaderProps> = ({ 
  activeTab, 
  onTabSelect, 
  tabs, 
  HeaderComponent 
}) => {

  // The handler now directly calls the navigation function passed in props
  const handleSelect = (eventKey: string | null): void => {
    if (eventKey !== null) {
      onTabSelect(eventKey);
    }
  };

  return (
    <div className="page-header-container">
      <Row>
        <Col>
          <Nav variant="tabs" activeKey={activeTab} onSelect={handleSelect}>
            {tabs.map((tab: string, i: number) => (
              <Nav.Item key={i}>
                <Nav.Link eventKey={tab}>{tab}</Nav.Link>
              </Nav.Item>
            ))}
          </Nav>
        </Col>
        <Col lg="2" className="claim-header-search"> 
          {/* Render the optional component if provided */}
          {HeaderComponent}
        </Col>
      </Row>
    </div>
  );
};

export default PageHeader2;